(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    var SMOOTH = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

    function scrollXTo(el, left) {
      try { el.scrollTo({ left: left, behavior: SMOOTH }); }
      catch (e) { el.scrollLeft = left; }
      setTimeout(function () {
        if (Math.abs(el.scrollLeft - left) > 2) el.scrollLeft = left;
      }, 500);
    }

    function applyTitre(root) {
      var titre = root.getAttribute('data-cg-titre');
      var sel = root.getAttribute('data-cg-titre-sel');
      if (!titre || !sel) return;
      var el = document.querySelector(sel);
      if (el && el.textContent.trim() !== titre) el.textContent = titre;
    }

    function init(root) {
      applyTitre(root);

      if (root.dataset.cgInit) return;
      root.dataset.cgInit = '1';

      var stage = root.querySelector('[data-cg-stage]');
      var slides = [].slice.call(root.querySelectorAll('[data-cg-slide]'));
      var thumbRow = root.querySelector('[data-cg-thumbs]');
      var thumbs = [].slice.call(root.querySelectorAll('[data-cg-thumb]'));
      var counter = root.querySelector('[data-cg-counter]');
      var prev = root.querySelector('[data-cg-prev]');
      var next = root.querySelector('[data-cg-next]');
      var total = slides.length;
      var cur = 0;
      var lock = 0;

      if (!stage || total === 0) return;

      function revealThumb(el) {
        if (!thumbRow || !el) return;
        var left = el.offsetLeft, w = el.offsetWidth;
        var sl = thumbRow.scrollLeft, cw = thumbRow.clientWidth;
        if (left < sl) scrollXTo(thumbRow, Math.max(0, left - 8));
        else if (left + w > sl + cw) scrollXTo(thumbRow, left + w - cw + 8);
      }

      function paint(i) {
        cur = i;
        for (var k = 0; k < thumbs.length; k++) {
          thumbs[k].setAttribute('aria-current', k === i ? 'true' : 'false');
        }
        if (counter) counter.textContent = (i + 1) + '/' + total;
        if (prev) prev.disabled = (i === 0);
        if (next) next.disabled = (i === total - 1);
        revealThumb(thumbs[i]);
      }

      function go(i) {
        if (i < 0 || i > total - 1 || i === cur) return;
        paint(i);
        lock = Date.now() + 800;
        scrollXTo(stage, i * stage.clientWidth);
      }

      var raf = 0;
      stage.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var w = stage.clientWidth;
          if (!w) return;
          var i = Math.round(stage.scrollLeft / w);
          if (Date.now() < lock) {
            if (i === cur) lock = 0;
            return;
          }
          if (i !== cur && i >= 0 && i < total) paint(i);
        });
      }, { passive: true });

      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { go(i); });
      });
      if (prev) prev.addEventListener('click', function () { go(cur - 1); });
      if (next) next.addEventListener('click', function () { go(cur + 1); });

      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
      });

      var rt = 0;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(function () {
          stage.scrollTo({ left: cur * stage.clientWidth, behavior: 'auto' });
        }, 150);
      });

      paint(0);
    }

    function scan() {
      document.querySelectorAll('[data-cg]').forEach(init);
    }

    scan();
    document.addEventListener('DOMContentLoaded', scan);
    document.addEventListener('shopify:section:load', scan);
    document.addEventListener('shopify:block:select', scan);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["galerie-produits"] && !Shopify.designMode) return;
  try {
    (function () {
    var SMOOTH = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

    // scroll horizontal anime, avec repli si le navigateur n'honore pas "smooth"
    // (onglet en arriere-plan, iframe de l'editeur, vieux Safari...)
    function scrollXTo(el, left) {
      try { el.scrollTo({ left: left, behavior: SMOOTH }); }
      catch (e) { el.scrollLeft = left; }
      setTimeout(function () {
        if (Math.abs(el.scrollLeft - left) > 2) el.scrollLeft = left;
      }, 500);
    }

    function applyTitre(root) {
      var titre = root.getAttribute('data-cg-titre');
      var sel = root.getAttribute('data-cg-titre-sel');
      if (!titre || !sel) return;
      var el = document.querySelector(sel);
      if (el && el.textContent.trim() !== titre) el.textContent = titre;
    }

    function init(root) {
      applyTitre(root);

      if (root.dataset.cgInit) return;
      root.dataset.cgInit = '1';

      var stage = root.querySelector('[data-cg-stage]');
      var slides = [].slice.call(root.querySelectorAll('[data-cg-slide]'));
      var thumbRow = root.querySelector('[data-cg-thumbs]');
      var thumbs = [].slice.call(root.querySelectorAll('[data-cg-thumb]'));
      var counter = root.querySelector('[data-cg-counter]');
      var prev = root.querySelector('[data-cg-prev]');
      var next = root.querySelector('[data-cg-next]');
      var total = slides.length;
      var cur = 0;
      var lock = 0; // ignore les events de scroll tant qu'on anime vers une cible

      if (!stage || total === 0) return;

      function revealThumb(el) {
        if (!thumbRow || !el) return;
        var left = el.offsetLeft, w = el.offsetWidth;
        var sl = thumbRow.scrollLeft, cw = thumbRow.clientWidth;
        if (left < sl) scrollXTo(thumbRow, Math.max(0, left - 8));
        else if (left + w > sl + cw) scrollXTo(thumbRow, left + w - cw + 8);
      }

      function paint(i) {
        cur = i;
        for (var k = 0; k < thumbs.length; k++) {
          thumbs[k].setAttribute('aria-current', k === i ? 'true' : 'false');
        }
        if (counter) counter.textContent = (i + 1) + '/' + total;
        if (prev) prev.disabled = (i === 0);
        if (next) next.disabled = (i === total - 1);
        revealThumb(thumbs[i]);
      }

      function go(i) {
        if (i < 0 || i > total - 1 || i === cur) return;
        paint(i);
        lock = Date.now() + 800;
        scrollXTo(stage, i * stage.clientWidth);
      }

      var raf = 0;
      stage.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var w = stage.clientWidth;
          if (!w) return;
          var i = Math.round(stage.scrollLeft / w);
          // pendant une animation declenchee par un clic, on ne suit pas les
          // positions intermediaires : elles feraient clignoter la miniature active
          if (Date.now() < lock) {
            if (i === cur) lock = 0;
            return;
          }
          if (i !== cur && i >= 0 && i < total) paint(i);
        });
      }, { passive: true });

      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { go(i); });
      });
      if (prev) prev.addEventListener('click', function () { go(cur - 1); });
      if (next) next.addEventListener('click', function () { go(cur + 1); });

      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
      });

      // la largeur d'une slide change au resize : on se recale sur l'image courante
      var rt = 0;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(function () {
          stage.scrollTo({ left: cur * stage.clientWidth, behavior: 'auto' });
        }, 150);
      });

      paint(0);
    }

    function scan() {
      document.querySelectorAll('[data-cg]').forEach(init);
    }

    scan();
    document.addEventListener('DOMContentLoaded', scan);
    document.addEventListener('shopify:section:load', scan);
    document.addEventListener('shopify:block:select', scan);
  })();
  } catch(e) { console.error(e); }
})();

})();
